// Text info
const rotateChair =  `
כיסא תנועתי טלסקופי גובה משתנה -עם ידית הגבהה - מושב עגול - אחד השמות הנפוצים לכיסא זה הינו "כיסא קשב"
- אך שמו לפעמים יכול להטעות מכיוון שהכיסא המיוחד הזה פשוט מתאים לכולם ולאו דווקא לילדים בעלי הפרעות קשב וריכוז.
              התנועתיות המתאפשרת ליושבים על הכיסא היא בריאה ומעודדת זרימת דם ופעילות יעילה יותר של המוח.
                                                          הכיסא עשוי פלסטיק ובעל בוכנה פנימית לשינוי הגובה.
                                                                          הבסיס והמושב של הכיסא עשויים גומי.
                                                                                 הכיסא מתאים לכיתות ג' ומעלה.`

//--------------------------------------------------------------------------------------------------------------------------------

export const products = [
    {
      id: 1,
      name: 'אופני כושר  דגם BENX',
      path: './ModelsGLB/Products/BicycleYellowGroup.glb',
      infoPath: './ModelsGLB/Products/BicycleYellow.glb',
      position: [-5.7,0.65, -6.0],
      rotation: [0, Math.PI / 2, 0],
      infoPosition: [0, 0, 0],
      textInfo: `
      אופני כושר  דגם BENX עם רמת התנגדות משתנה, בעלי שולחן עבודה מתכוונן. גובה השולחן וגובה המושב מתכווננים.
       מתאים לשילוב בכיתה פעילה, חדרי הכלה ולמסדרונות בית ספר. 
      ניתן להניח על מגש הכתיבה מחברת, ספר, מחשב נייד או כל דבר אחר וללמוד תוך כדי תנועה.
       המכשיר קל לנשיאה וניתן לקיפול לאיחסון נוח. משטח הישיבה ומשענת הגב מרופדים.`
    },
    {
      id: 2,
      name: 'שולחן עבודת צוות',
      path: './ModelsGLB/Products/Table_g.glb',
      infoPath: './ModelsGLB/Products/Table_g.glb',
      position: [0,0.4, -6.5],
      rotation: [0, Math.PI / 2, 0],
      infoPosition: [0, 0, 0],
      textInfo: `
      שולחן עבודת צוות - "שולחן מייקרס" שולחן עמידה קבוצתי עם מסגרת לעבודות יצירה ומשחק קבוצתי.
       בתוספת 12 קופסאות איחסון בגדלים שונים. השולחן מתאים כשולחן עמידה ו\או כשולחן מורה.
        משטח העבודה הינו משטח מחיק. השולחן מגיע עם 6 גלגלים עם אפשרות נעילה לצורך שינוע במרחב הלמידה.
        מומלץ למלא את המגירות במשחקים חינוכיים, אביזרי עזר ללמידה וחומרי יצירה.`
    },
    {
      id: 3,
      name: 'כסא פיזיו',
      path: './ModelsGLB/Products/PhysioChairGroup.glb',
      infoPath: './ModelsGLB/Products/PhysioChair2.glb',
      position: [-4.1, 0.35, 0.8],
      rotation: [0, Math.PI / -2, 0],
      infoPosition: [0 ,-1, -3],
      textInfo: `
      כיסא מיוחד לישיבה ארגונומית במשרד או בכיתה.
       גודל הכדור מותאם לגיל המשתמש. לכיתות א-ב מומלץ להשתמש בכדור בגודל 45 ס"מ, לכיתות ג-ו מומלץ להשתמש בכדור בגודל 55 ס"מ ולבוגרים בכדור בגודל 65 ס"מ.
        הגמישות של הכדור מאפשרת למשתמש ללמוד בתנועה ויחד עם זאת תורמת לצורת ישיבה נכונה ולשמירה על גב זקוף. הכיסא מגיע עם גלגלים בעלי מנגנון נעילה.`
    },
    {
      id: 4,
      name: 'שולחן פדלים אליפטיקל  דגם ORI',
      path: './ModelsGLB/Products/BicycleGroup.glb',
      infoPath: './ModelsGLB/Products/Bicycle2B.glb',
      position: [-6.8, 0.60, -7.55],
      rotation: [0, Math.PI / -2, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      מכשיר כושר ללמידה תוך כדי תנועה. הפעילות על המכשיר מתבצעת בעמידה ומדמה עלייה במדרגות.
       מגש הכתיבה/ קריאה מתכוונן וניתן לשנות את הזווית שלו בהתאם לשימוש.
       גובה המושב וגובה השולחן מתכווננים להתאמה מקסימלית למידות המשתמש.
       המושב מרופד ונוח לישיבה. המכשיר מומלץ לשילוב בכיתות פעילות ו/או בפינות פעילות בבתי ספר.`
    },
    {
      id: 5,
      name: 'כסא תנועתי - מושב עגול',
      path: './ModelsGLB/Products/Hedom.glb',
      infoPath: './ModelsGLB/Products/Hedom.glb',
      position: [2, 0.28, -1],
      infoPosition: [0 , 0 , 0],
      textInfo: rotateChair
    },
    {
      id: 6,
      name: 'סט לוחות מחיקים קטנים עם מעמד',
      path: './ModelsGLB/Products/Board.glb',
      infoPath: './ModelsGLB/Products/Board.glb',
      position: [4.5, 0.87, -2.5],
      rotation: [0, Math.PI / -2 , 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      מעמד ללוחות מחיקים אישיים - מיועד לעבודה בקבוצות כאשר בסוף הפעילות כל תלמיד יכול להציג את מה שכתב ולפתח שיח קבוצתי.`
    },
    {
      id: 7,
      name: 'שולחן GROUP עם כסאות נשלפים',
      path: './ModelsGLB/Products/TableChair2.glb',
      infoPath: './ModelsGLB/Products/TableChair2.glb',
      position: [2, 0.4, -4.5],
      rotation: [0, Math.PI * 3, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן קבוצתי עם 4 כיסאות נשלפים הניתנים לאחסון מתחת לשולחן.
       כל כיסא מגיע עם מנגנון קפיץ כאשר ישיבה על הכיסא מקבעת אותו במקום אך המושב מאפשר סיבוב מצד לצד ותנועה של התלמיד. המשטח עשוי עץ בציפוי מלמין יצוק.
        שלדת השולחן עשויה מתכת מאסיבית. מתאים ללמידה קבוצתית, למרחבי למידה שונים וחדרי הכלה.`
    },
    {
      id: 8,
      name: 'שולחן חצי ירח',
      path: './ModelsGLB/Products/MoonTables.glb',
      infoPath: './ModelsGLB/Products/MoonTable.glb',
      position: [-4.3, 0.318, 1],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן חצי ירח (שולחן ביס) אישי מודולרי - 
      ניתן לחבר מספר שולחנות אחד לשני כדי ליצור צורות ישיבה שונות. 8 שולחנות יוצרים צורה של מעגל.
       המשטח עשוי עץ בציפוי שכבת מלמין השומרת על השולחן מנזקים.
       המשטח עטוף קנט יצוק. רגלי השולחן עשויות ברזל מגלוון. `
    },
    {
      id: 9,
      name: 'שולחן טרפז',
      path: './ModelsGLB/Products/Trapezes.glb',
      infoPath: './ModelsGLB/Products/Trapez.glb',
      position: [-1, 0.33, -1.3],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן טרפז אישי מודולרי - ניתן לחבר מספר שולחנות אחד לשני כדי ליצור צורות ישיבה שונות.
       6 שולחנות יוצרים צורה של מעגל.
        המשטח עשוי עץ בציפוי שכבת מלמין השומרת על השולחן מנזקים.
         המשטח עטוף קנט יצוק.
          רגלי השולחן עשויות ברזל מגלוון. `
    },
    {
      id: 10,
      name: 'כסא תנועתי - מושב עגול',
      path: './ModelsGLB/Products/Hedom.glb',
      infoPath: './ModelsGLB/Products/Hedom.glb',
      position: [3, 0.28, -1.5],
      infoPosition: [0 , 0 , 0],
      textInfo: rotateChair
    },
    {
      id: 11,
      name: 'כסא תנועתי - מושב עגול', 
      path: './ModelsGLB/Products/HedomGroup.glb',
      infoPath: './ModelsGLB/Products/Hedom.glb',
      position: [-1, 0.28, -1.3],
      infoPosition: [0 , 0 , 0],
      textInfo: rotateChair
    },
    {
      id: 12,
      name: 'שק איגרוף עומד',
      path: './ModelsGLB/Products/Boxing.glb',
      infoPath: './ModelsGLB/Products/Boxing.glb',
      position: [4.5, 0.9, -8.5],                      // position: [-6.5, 0.9, 2.2]
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שק איגרוף עומד עם בסיס למילוי  מים.
       ניתן להעמיד את השק ב"פינת אנרגיה" בכיתה, בחדרי הכלה או אפילו במסדרון.
        הרעיון שעומד מאחורי השק הוא כדי לאפשר לילדים לפרוק אנרגיה, לפרוק תסכול וכעס במקום מוסכם ומסודר.`
    },
    {
      id: 13,
      name: 'שולחן במבה',
      path: './ModelsGLB/Products/Bamba.glb',
      infoPath: './ModelsGLB/Products/Bamba.glb',
      position: [-4.18, 0.32, -3],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן במבה - שולחן הקנייה - שולחן מומלץ לעבודה בקבוצות קטנות.
       מסביב לשולחן יושבים 3-4 ילדים כאשר מולם יש מקום למורה או לתלמיד נוסף.
        ניתן לקחת את השולחן גם עם רגליים נמוכות ולהתשמש בו כשולחן לישיבה נמוכה על הרצפה או על כסאות מותאמים.
         המשטח עשוי עץ בציפוי שכבת מלמין השומרת על השולחן מנזקים. המשטח עטוף קנט יצוק. רגלי השולחן עשויות ברזל מגלוון.`
    },
    {
      id: 14,
      name: 'כיסא אישי ',
      path: './ModelsGLB/Products/ChairGroup.glb',
      infoPath: './ModelsGLB/Products/Chair2glb.glb',
      position: [-4.24, 0.26, -3],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      כיסא אישי עשוי מפלסטיק יצוק ואיכותי. `
    },
    {
      id: 15,
      name: 'שולחן עמידה זוגי ',
      path: './ModelsGLB/Products/StandingTableLong.glb',
      infoPath: './ModelsGLB/Products/StandingTableLong.glb',
      position: [-2.85, 0.365, -7.85],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן עמידה זוגי- פלטה MDF 18 מ"מ, דופן PU צבע תכלת, עם FOOT REST.
       - משענת לרגל.
        השולחן מתאים למרחבי למידה גמישים המאפשרים לתלמיד לעבור בין צורות ישיבה\עמידה במהלך שיעור, ללא צורך בהפרעה למהלך השיעור.
        השולחן בדרך כלל משולב עם כיסא בר מוגבה וכך התלמיד יכול להחליט איך נוח לו ללמוד בכל רגע נתון ולהיות פחות סטטי.`
    },
    ,
    {
      id: 16,
      name: 'שולחן עמידה אישי',
      path: './ModelsGLB/Products/StandingTableShort.glb',
      infoPath: './ModelsGLB/Products/StandingTableShort.glb',
      position: [-1.7, 0.365, -7],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן עמידה אישי - פלטה MDF 18 מ"מ, דופן PU צבע תכלת, עם FOOT REST. - משענת לרגל.
       השולחן מתאים למרחבי למידה גמישים המאפשרים לתלמיד לעבור בין צורות ישיבה\עמידה במהלך שיעור, ללא צורך בהפרעה למהלך השיעור. 
       השולחן בדרך כלל משולב עם כיסא בר מוגבה וכך התלמיד יכול להחליט איך נוח לו ללמוד בכל רגע נתון ולהיות פחות סטטי.`
    },
    {
      id: 17,
      name: 'כסא בר',
      path: './ModelsGLB/Products/StoolGroup.glb',
      infoPath: './ModelsGLB/Products/Stool.glb',
      position: [-1.7, 0.34, -7.8],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      כיסא בר גובה מושב 60 ס"מ עם משענת רגליים - משמש לישיבה גבוהה מול שולחנות עמידה ושולחנות בר.`
    },
    {
      id: 18,
      name: 'שולחן ארגונומי מתכוונן',
      path: './ModelsGLB/Products/AdjustmentTableGroup.glb',
      infoPath: './ModelsGLB/Products/AdjustmentTable.glb',
      position: [2.66, 0.3, -1],
      rotation: [0, Math.PI / -0.32, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן מתכוונן עם מגירה ללמידה גמישה - התלמיד יכול לעבור ממצב ישיבה למצב עמידה ע"י לחיצה על ידית וכך לשלוט בגובה השולחן תוך כדי שיעור.
       רגלי השולחן מכילות 2 בוכנות אשר מאפשרות את המשחק בגבהים. לשולחן 2 גלגלים לצורכי ניוד מהיר בכיתה.
       משטח השולחן עשוי עץ בציפוי מלמין עם קנט יצוק.`
    },
    {
      id: 19,
      name: 'שולחן עגול קבוצתי - משטח פלסטיק',
      path: './ModelsGLB/Products/TableLow.glb',
      infoPath: './ModelsGLB/Products/TableLow.glb',
      position: [1, 0.25, 0.8],
      rotation: [0, Math.PI / -5, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שולחן קבוצתי המתאים ל4-5 ילדים.
       השולחן עשוי פלסטיק איכותי ועבה במרקם נעים למגע.
        השולחן משמש כשולחן בחדרי הכלה, שולחן קבוצתי בכיתות וכמו כן יכול לשמש כשולחן רצפתי לישבה נמוכה.
        הרגליים המתכווננות ע"י שינוי גובה הבורג מאפשרות לשנות את יעוד וגובה השולחן בהתאם לצורך.`
    },
    {
      id: 20,
      name: 'כיסא רצפתי מרופד מתקפל',
      path: './ModelsGLB/Products/FloorChairGroup.glb',
      infoPath: './ModelsGLB/Products/FloorChair.glb',
      position: [1, 0.04, 0.8],
      rotation: [0, Math.PI / -5, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      כיסא מיוחד לישיבה נמוכה על הקרקע. הכיסא מרופד ובעל משענת הניתנת לכוונון במספר זוויות.
       הכיסא נפתח עד למצב שטוח - זווית 180 מעלות לצורך איחסון קל ונוח ומגיע עם רצועת נשיאה.
        הכיסא הרצפתי מתאים לישבה מול שולחן נמוך (40-50 ס"מ) ולשילוב במרחבי למידה אלטרנטיביים.`
    },
    {
      id: 21,
      name: 'שטיח דשא סינטטי עגול בצבעים שונים',
      path: './ModelsGLB/Products/CarpetBlue.glb',
      infoPath: './ModelsGLB/Products/CarpetBlue.glb',
      position: [1, 0.02, 0.8],
      rotation: [0, Math.PI / -1.5, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      שטיח דשא סינטטי בקוטר 200 ס"מ - מתאים ליצירת פינות ישיבה מיוחדות בכיתה ויוצר אווירה נעימה וצבעונית בחלל הלמידה.
      ניתן גם להזמין במידות קטנות יותר בהתאמה אישית.
      צבעים: ירוק בהיר, כתום, כחול. `
    },
    {
      id: 22,
      name: 'פוף אגס',
      path: './ModelsGLB/Products/Poof.glb',
      infoPath: './ModelsGLB/Products/Poof.glb',
      position: [4,0.3, 1],
      rotation: [0, Math.PI / -0.8, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      פוף לשילוב במרחבי למידה, כיתות וחדרי הכלה - הפוף עשוי בד שמשונית איכותי הניתן לניקוי ותחזוקה. `
    },

    {
      id: 23,
      name: 'סט כורסאות מרופדות 2+1',
      path: './ModelsGLB/Products/SofaGroup.glb',
      infoPath: './ModelsGLB/Products/Sofa.glb',
      position: [5.65,0.39, 1.35],
      rotation: [0, 0, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      סט כורסאות לכיתה / מרחב למידה. הכורסאות מרופדות ומצופות בד שמשונית איכותי, נעים וקל לניקוי. `
    },
    {
      id: 24,
      name: 'שידת מגירות',
      path: './ModelsGLB/Products/Storage_1.glb',
      infoPath: './ModelsGLB/Products/Storage_1.glb',
      position: [-7.3,0.46, -3.68],
      rotation: [0, Math.PI / 2, 0],
      infoPosition: [0 , 0 , 0],
      textInfo: `
      תאים קטנים  - 18 תאי איחסון + 18 מגירות פלסטיק. מסגרת השידה עשויה עץ בציפוי מלמין יצוק.`
    },
  ]